<main class="main-container">
  <div class="main-container--border">
    <p class="scroll"><span>↓</span> scroll to continue <span>↓</span></p>
  </div>
  <app-hero class="section"></app-hero>
  <app-resume class="section"></app-resume>
  <app-portfolio class="section"></app-portfolio>
  <app-contact class="section"></app-contact>
</main>
